import { Link } from 'gatsby'
import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { faBars} from '@fortawesome/free-solid-svg-icons'
import Img from 'gatsby-image'
import { graphql, useStaticQuery} from "gatsby"


export default function Navbar() {
    const data  = useStaticQuery(graphql`
    query MyQuery {
        logo: file(relativePath: {eq: "VT.png"}) {
          childImageSharp {
            fluid{
                   ...GatsbyImageSharpFluid
            }
          }
        }
      }
      
    `)

    const menuChangs = () =>{
        let element = document.getElementById("navmenu")
        element.classList.toggle("active")
    }
    return (
        <div>
            <div className="logoWrapper">
                <Link to="/" id="home">
                    <Img fluid={data.logo.childImageSharp.fluid}/>
                    <p>VisioTherapy</p>
                </Link>
            </div>
            <nav className='navbar'>
                <button className='mobilemenu' onClick={menuChangs}>
                    <FontAwesomeIcon icon={faBars} size="2x" />
                </button>
                <ul id="navmenu" className="navLinks">
                    <Link to="/" id="home"><li>Home</li></Link>
                    <Link to="/manifesto" id="manifesto"><li>Manifesto</li></Link>
                    <Link to="/requestaccess" id="requestaccess"><li>Request Access</li></Link>
                </ul>
            </nav>
        </div>
    )
}